module.exports = __webpack_public_path__ + "img/lg_ring_skip_skip_1_0@3x.5d6a1a18.png";